import React from "react";
import { Formik } from "formik";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "us.helper/types";
import * as Actions from "actions";
import { EditorForm } from "../EditorForm";
import { useLocation } from "react-router-dom";
import { getRuleExpression } from "../../Functions";
import { SaveTemplateRules } from "../../Repository";
import { RuleEditorValidationSchema } from "components/RuleEditor/Validations";

interface IRuleEditor {
  onCancel: () => void;
}

const RuleEditor: React.FC<IRuleEditor & PropsFromRedux> = (props) => {
  const { templateRules, template, tokens, onCancel, updateRule } = props;
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const templateId = urlParams.get("id");

  const handleSubmit = (values: any) => {
    const ruleExpressions = getRuleExpression(values, tokens);
    const saveParams = SaveTemplateRules.call({
      ...template.data,
      ruleExpressions,
    });
    updateRule &&
      updateRule({
        templateId,
        saveParams,
      });
  };

  return (
    <Formik
      initialValues={{
        rules: templateRules.data.rules,
      }}
      onSubmit={handleSubmit}
      enableReinitialize
      validateOnMount
      validateOnChange
      validateOnBlur
      validationSchema={RuleEditorValidationSchema(tokens)}
    >
      {({ handleSubmit }: any) => (
        <EditorForm handleSubmit={handleSubmit} onCancel={onCancel} />
      )}
    </Formik>
  );
};

const mapStateToProps = (state: RootState) => {
  const { templateEditor, templatesHistory } = state;
  const { parameters, templateRules } = templateEditor;
  const { template } = templatesHistory;

  return {
    tokens: parameters.standard.dataTokens,
    templateRules,
    template,
  };
};

const { templateRule } = Actions.templateEditor;

const mapDispatchToProps = {
  updateRule: templateRule.save,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(RuleEditor);
